import React from "react";
import "./UGGraph.scss";

import {
  AreaChart,
  XAxis,
  YAxis,
  Area,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
interface Props {
  data: Array<any>;
  product_type: any;
}

const UGGraph: React.FC<Props> = ({data, product_type}) => {
  const allColor = "#AC43FF";
  const carColor = "#E4506F";
  const bikeColor = "#4FA13B";
  const healthColor = "#FC6509";
  const termColor = "#FDC031";
  const investmentColor = "#3569B6";
  const travelColor = "#AC43FF";
  const commercialColor = "#3A4855";
  const giColor = "#1EBC96";
  return (
    <div style={{width: "100%", height: 300, marginBottom: 16}}>
      <ResponsiveContainer>
        <AreaChart
          data={data}
          margin={{top: 10, right: 30, left: 0, bottom: 0}}
        >
          <defs>
            <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset="5%"
                stopColor={
                  product_type === "all"
                    ? allColor
                    : product_type === "car"
                    ? carColor
                    : product_type === "bike"
                    ? bikeColor
                    : product_type === "health"
                    ? healthColor
                    : product_type === "term"
                    ? termColor
                    : product_type === "investment"
                    ? investmentColor
                    : product_type === "travel"
                    ? travelColor
                    : product_type === "commercial"
                    ? commercialColor
                    : product_type === "gi"
                    ? giColor
                    : ""
                }
                stopOpacity={0.4}
              />
              <stop offset="95%" stopColor="#fff" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" />
          <YAxis />
          <CartesianGrid strokeDasharray="0 0" strokeOpacity={0.3} />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="a"
            stroke={carColor}
            fillOpacity={1}
            fill="url(#color)"
          />
          <Area
            type="monotone"
            dataKey="b"
            stroke={bikeColor}
            fillOpacity={1}
            fill="url(#color)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UGGraph;
